// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ANILivePrice.css */

.ani-wrapper {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.ani-window {
  width: 100%;
  max-width: 500px;
}

.convert-box {
  margin: 1rem 0;
  font-size: 14px;
}

.converter {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.field {
  display: flex;
  flex-direction: column;
}

input {
  padding: 4px;
  margin: 4px 0;
  font-family: inherit;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/LivePrice/ANILivePrice.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":["/* src/components/ANILivePrice.css */\n\n.ani-wrapper {\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.ani-window {\n  width: 100%;\n  max-width: 500px;\n}\n\n.convert-box {\n  margin: 1rem 0;\n  font-size: 14px;\n}\n\n.converter {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n}\n\ninput {\n  padding: 4px;\n  margin: 4px 0;\n  font-family: inherit;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
